export default "/public/app-main/static/image/cc016e1e05a3f33b7c3310ccf2aa1881.png";